var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoProperties({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 133,
    viewBox: "0 0 121 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14088_120381)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 73,
    r: 59,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1582 51.7017L94.9931 66.6375C95.0822 66.9012 95.1715 67.165 95.2609 67.4287L95.3346 67.6466C95.3321 72.0846 91.6614 75.7232 87.126 75.7232C84.6611 75.7232 82.4871 74.6729 80.9675 72.9744L80.5948 72.5579L80.2222 72.9744C78.7026 74.6729 76.5286 75.7232 74.0637 75.7232C71.5988 75.7232 69.4248 74.6729 67.9051 72.9744L67.5325 72.5579L67.1598 72.9744C65.6402 74.6729 63.4662 75.7232 61.0013 75.7232C58.5364 75.7232 56.3624 74.6729 54.8427 72.9744L54.4701 72.5579L54.0975 72.9744C52.5778 74.6729 50.4038 75.7232 47.9389 75.7232C45.474 75.7232 43.3 74.6729 41.7804 72.9744L41.4078 72.5579L41.0351 72.9744C39.5155 74.6729 37.3415 75.7232 34.8766 75.7232C30.3412 75.7232 26.6706 72.0847 26.668 67.6465C26.6934 67.5714 26.7189 67.4962 26.7443 67.421C26.8327 67.1599 26.9212 66.8988 27.0094 66.6378L37.8445 51.7017C38.1933 51.259 38.7034 51 39.2307 51H82.7719C83.2994 51 83.8094 51.259 84.1582 51.7017Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.127 81.0056C88.4617 81.0056 89.7515 80.7814 90.9811 80.4098V101.942C90.9811 104.025 89.2617 105.729 87.127 105.729H83.2729V84.7933V84.2933H82.7729H69.7105H69.2105V84.7933V105.729H34.8776C32.7429 105.729 31.0234 104.025 31.0234 101.942V80.3513C34.455 81.3377 38.2521 81.0564 41.409 79.3465C45.3794 81.4927 50.5008 81.4927 54.4711 79.3464C58.4416 81.4928 63.5592 81.4926 67.5335 79.3462C71.5079 81.4928 76.6219 81.4928 80.5962 79.346C82.5792 80.4238 84.8238 81.0056 87.127 81.0056ZM56.6482 98.1553H57.1482V97.6553V84.7937V84.2937H56.6482H39.2317H38.7317V84.7937V97.6553V98.1553H39.2317H56.6482Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.8667,
    cy: 47.8667,
    r: 16.8667,
    fill: "#714787"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.8643,
    cy: 47.8604,
    r: 11.2667,
    fill: "#714787",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0492 44.1457C63.3216 43.4181 62.0413 42.9129 60.8644 42.8807M57.6797 51.0457C58.3643 51.958 59.6362 52.4778 60.8644 52.5223M60.8644 42.8807C59.4645 42.8431 58.211 43.4771 58.211 45.2067C58.211 48.3915 64.0492 46.7991 64.0492 49.9838C64.0492 51.8008 62.4951 52.5805 60.8644 52.5215M60.8644 42.8807V40.9609M60.8644 52.5223V54.7609",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.3984V19.9984",
    stroke: "#714787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.6016H20.0201",
    stroke: "#714787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14088_120381"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProperties);
export default __webpack_public_path__ + "static/media/noProperties.08cc87fefe26c6cac46cf820012223d9.svg";
export { ForwardRef as ReactComponent };